export default "__VITE_ASSET__EBVcStMv__"